import React, { useEffect } from 'react';
import {BrowserRouter, Routes, Route } from 'react-router-dom';

import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { StyledEngineProvider } from '@mui/material/styles';
import './App.css';
import percentSVG from './data/percent.svg'; // Adjust the path as needed


import { Dashboard, Login, Profile, Help } from './pages';
import { Navbar } from './components';
import { useStateContext } from './contexts/ContextProvider';

import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import ProtectedLayout from './components/ProtectedLayout';
import { MyApolloClient } from './components';



import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';



const cache = createCache({
  key: 'css',
  prepend: true, // Ensure Emotion's styles are injected first
});

const isTokenExpired = (token) => {
  try {
    const payloadBase64 = token.split('.')[1];
    const decodedPayload = atob(payloadBase64);
    const payload = JSON.parse(decodedPayload);
    const exp = payload.exp;
    const now = Date.now() / 1000; // Get current date in Unix timestamp (seconds)
    return now > exp;
  } catch (error) {
    // In case of an error (e.g., token is malformed), assume the token is invalid
    console.error('Error decoding token:', error);
    return true;
  }
};

const App = () => {

  const {installPromptEvent,setInstallPromptEvent,isLogged, setIsLogged} = useStateContext();
  useEffect(() => {
    const beforeInstallPromptHandler = (e) => {
      e.preventDefault(); // Prevent the mini-infobar from appearing
      setInstallPromptEvent(e); // Save the event
    };

    window.addEventListener('beforeinstallprompt', beforeInstallPromptHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', beforeInstallPromptHandler);
    };
  }, [setInstallPromptEvent]);

  useEffect(() => {
    const token = localStorage.getItem('jwt');
  
    if (token && !isTokenExpired(token)) {
      // If the token is present and not expired
      setIsLogged(true);
      console.log("Token is valid and did not expire."); // Corrected log statement
    } else {
      // If the token is not present or expired
      localStorage.removeItem('jwt'); // Clear the expired token
      setIsLogged(false);
      console.log("Token is either not present or expired."); // Corrected log placement and message
      if(token && isTokenExpired(token)){
        if ('caches' in window) { // Again, ensure caches are supported
          caches.keys().then(names => {
              return Promise.all(names.map(name => caches.delete(name)));
          }).then(() => {
              console.log("Caches cleared. Reloading the page to fetch latest version.");
              window.location.reload();
          });
        }
      }
      
    }
  
    // Function to handle storage changes
    const handleStorageChange = (e) => {
      if (e.key === 'jwt') {
        const newToken = e.newValue;
        if (newToken && !isTokenExpired(newToken)) {
          setIsLogged(true);
        } else {
          setIsLogged(false);
        }
      }
    };
  
    // Add event listener for storage changes
    window.addEventListener('storage', handleStorageChange);
  
    // Cleanup on unmount
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
  <ApolloProvider client={MyApolloClient}>
    <CacheProvider value={cache}>
      <StyledEngineProvider injectFirst>
        <BrowserRouter>
        <div className="flex relative">
          <div className={`bg-gray1 min-h-screen w-full`}
                style={{ 
                    backgroundImage: `url(${percentSVG})`, 
                    backgroundSize: '400px 80px', // Start with the size of the SVG canvas
                    backgroundColor: '#d6d6d6',
                    backgroundRepeat: 'repeat'
                }}>
                
                {!isLogged ? (
                <Login />
              ) : (
                <>
                <div className="sticky top-0 bg-yellow1 navbar w-full" >
                  <Navbar/>
                </div>
                <div>
                <Routes>
                  <Route path="/" element={<ProtectedLayout />}>
                    {/* Protected routes here */}
                    <Route index element={<Dashboard />} />
                    <Route path="/Help" element= {<Help/>}  />
                    {/* More protected routes */}
                  </Route>
                  {/* Potentially more routes that are outside the ProtectedLayout */}
                </Routes>
                </div>
                </> 
                )}
          </div>
        </div>
        </BrowserRouter>
      </StyledEngineProvider>
    </CacheProvider>
  </ApolloProvider>


  )
}

export default App